export default __webpack_public_path__ + "static/media/windows95-announcement.a4eb11f4.gif";